import React from "react";

interface CircularProgressProps {
    valueNum?: number;
    secondValueNum?: number;
    unit?: string;
    percent?: number;
    styles?: React.CSSProperties;
}

const CircularProgress = ({ valueNum = 151, secondValueNum = 100, unit, percent = 33.3, styles }: CircularProgressProps) => {
  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (circumference * percent) / 100;

  const secondValue = Math.round(secondValueNum)
  const value = Math.round(valueNum)

  const getSecondValueFontSize = () => {
    if (!secondValue) return '12px';
    const length = secondValue?.toString().length;
    if (length < 2) return '18px'
    if (length < 3) return '14px'
    if (length < 4) return '12px'
    if (length < 5) return '10px'
    return '8px'
  }

  const getValueY = () => {
    if (secondValue && secondValue?.toString().length < 3) return '50%'
    if (!secondValue && unit) return '45%'
    if (secondValue) return '42%'
    return '50%'
  }

  return (
    <div style={styles} className="flex items-center justify-center h-screen bg-[#2b241c]">
      <svg width="80" height="80" viewBox="0 0 80 80">
        <defs>
          {/* Маска с PNG */}
          <mask id="brushMask">
            <image href="/brush_circle.png" width="80" height="80" />
          </mask>
        </defs>

        {/* Фоновой круг */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          stroke="#444"
          strokeWidth="8"
          fill="#1F1F1F"
          strokeLinecap="round"
        />

        {/* Прогресс с маской */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          stroke="gold"
          strokeWidth="8"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform="rotate(90 40 40)"
        />

        {/* Значение */}
        <text
          x="50%"
          y={getValueY()}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={getSecondValueFontSize()}
          fill="white"
          fontFamily="Segoe UI"
          fontWeight="400"
        >
          {secondValue && secondValue?.toString().length < 3 ? `${value}/${secondValue}` : value + "/"}
        </text>
        <text
          x="50%"
          y="60%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={getSecondValueFontSize()}
          fill="white"
          fontFamily="Segoe UI"
          fontWeight="400"
        >
          {secondValue && secondValue?.toString().length < 3 ? '' : secondValue}
        </text>

        {/* Единица измерения */}
        <text
          x="50%"
          y="60%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="10"
          fill="#434343"
          fontFamily="sans-serif"
          fontWeight="100"
          display={unit ? 'block' : 'none'}
        >
          {unit}
        </text>
      </svg>
    </div>
  );
};

export default CircularProgress;
